export default __webpack_public_path__ + "static/spitz-devices-mobile-897f9de1551e4f95d7714a1540fb673a.jpg";